import { Classified } from '../../rest/types/Classified'
import { AdsSortingFiltersVariant } from '../../components/AdsSortingFilters/styled'
import { Icons } from '../../components/Icon'
import { ListDisplayType } from '../../types/classified'

export function ClassifiedEmitterFiltersTransformer({
  t,
  classifieds,
  numberClassifieds,
  setDisplayType,
  displayTypeParams,
}: {
  t: any
  classifieds: Array<Classified>
  numberClassifieds?: number
  setDisplayType: (string: ListDisplayType) => void
  displayTypeParams?: ListDisplayType
}) {
  const displayOptions = [
    {
      label: t('listingSearchAdsDisplayCardOptionLabel'),
      value: ListDisplayType.Card,
      icon: Icons.gridOutline,
    },
    {
      label: t('listingSearchAdsDisplayListOptionLabel'),
      value: ListDisplayType.List,
      icon: Icons.listBlocksOutline,
    },
    {
      label: t('listingSearchAdsDisplayMapOptionLabel'),
      value: ListDisplayType.Map,
      icon: Icons.mapPinned,
    },
  ]

  return classifieds
    ? {
        displaySelect: {
          name: 'display',
          labelProps: { underlined: false },
          value: displayTypeParams,
          options: displayOptions,
          onChange: (e: any) => {
            setDisplayType(e.target.value)
          },
        },
        displaySwitch: {
          label: t('listingSearchAdsDisplayLabel'),
          value: displayTypeParams,
          options: displayOptions,
          onChange: (value: string) => setDisplayType(value as ListDisplayType),
        },
        adsNumber: `${
          numberClassifieds
            ? String(numberClassifieds)
            : String(classifieds?.length)
        } ${
          (classifieds?.length && classifieds?.length > 1) ||
          (numberClassifieds && numberClassifieds > 1)
            ? t('ads_number_listing_plural_label')
            : t('ads_number_listing_singular_label')
        }`,
        variant: AdsSortingFiltersVariant.secondary,
        isOpen: false,
      }
    : undefined
}
